/* istanbul ignore file */
import $ from 'jquery';
import _ from 'underscore';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import { withUiBlock } from '@bingads-webui/uiblocker';

// complex fields will impact value of other fields
const complexFields = ['EndDate', 'Status'];

function normalizeDate(i18n, value) {
  return value ? i18n.formatDate(new Date(value), { raw: 'MM/dd/yyyy', timeZone: 'UTC' }) : null;
}

export function inlineEditSave({
  id,
  fieldName,
  updatedItem,
  additionalPayload = {},
  disableBulk = false,
  refreshGrid = false,
}, {
  view,
  gridView,
  resource,
  scenario,
  i18n,
  i18nErrors,
  editorView,
  editorViewCallbackAfterUpdate,
  importNotificationCallback,
  isDateType = false,
  customBlockerTarget = null,
}) {
  const payload = _.clone(additionalPayload);
  // grid load will get date with ISO format: 2018-04-05T00:00:00.000Z,
  // we use bulk upsert api to do inline update, but bulk upsert cannot use the ISO format
  // as MT seems doing some sepcial transformation with this format
  // to fix this, we upsert with a MM/dd/yyyy format, but update grid with ISO format
  const $el = gridView ? gridView.$el : view.grid.gridView.$el;
  const uiBlockerTarget = customBlockerTarget ? $(customBlockerTarget) : $el;

  if (updatedItem) {
    payload[fieldName] = isDateType ? normalizeDate(i18n, updatedItem[fieldName]) : updatedItem[fieldName];
  } else {
    payload[fieldName] = null;
  }

  resource
    .update(id, payload, disableBulk ? undefined : { adapter: 'bulk' })
    .finally(withUiBlock(uiBlockerTarget))
    .then(() => {
      if (editorViewCallbackAfterUpdate && _.isFunction(editorViewCallbackAfterUpdate)) {
        editorViewCallbackAfterUpdate();
      }

      // show import related notifications if any
      if (importNotificationCallback && _.isFunction(importNotificationCallback)) {
        importNotificationCallback();
      }

      if (refreshGrid || _.contains(complexFields, fieldName)) {
        view.grid.gridView.refresh(true);
      } else if (updatedItem) {
        view.grid.gridView.trigger('didEdit', updatedItem);
      }
    })
    .catch((response) => {
      const errorMapping = {};
      const unexpectedError = i18n.getString('ErrorNumber_-1');

      if (!response || !response.errors) {
        errorMapping[fieldName] = unexpectedError;
      } else {
        const errors = i18nErrors.getBulkApiErrors(response.errors, scenario);

        if (!errors || !errors[0] || !errors[0].message) {
          errorMapping[fieldName] = unexpectedError;
        } else {
          errorMapping[fieldName] = errors[0].message;
        }
      }

      if (editorView && _.isFunction(editorView.setErrors)) {
        editorView.setErrors(errorMapping);
      } else {
        const alertHelper = new AlertHelper({ i18n });
        alertHelper.showError(errorMapping[fieldName]);
      }
    });
}

